/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Helper', ["$timeout",
    function ($timeout) {

        var helper = {
            displayStartWindow: "init",
            managerMode: true
        };

        return helper;
    }
]);



// WEBPACK FOOTER //
// ./js/services/tools/Helper.js